import React, { useEffect, useState } from 'react';
import { Home, MapPinHouse, ScanLine, Tag } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

const navigationItems = [
  { icon: Home, label: 'Home', to: '/' },
  { icon: MapPinHouse, label: 'Estate', to: '#' },
  { icon: Tag, label: 'Lots', to: '/lots' },
  { icon: ScanLine, label: 'Scan', to: '/qr-scanner' },
];

const BottomNavigation = () => {
  const { pathname } = useLocation();

  const [bottomPadding, setBottomPadding] = useState(0);

  useEffect(() => {
    const calculateBottomPadding = () => {
      // Calculate the difference between window height and visual viewport height
      // This accounts for Safari's dynamic UI bars
      if (window.visualViewport) {
        const safeArea = window.innerHeight - window.visualViewport.height;
        setBottomPadding(Math.max(0, safeArea));
      } else {
        // Fallback for browsers without visualViewport API
        // Check if we're on iOS Safari
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if (isIOS) {
          // Use a reasonable default for iOS (typically 0-34px depending on device)
          setBottomPadding(window.innerHeight > 800 ? 34 : 0);
        } else {
          setBottomPadding(0);
        }
      }
    };

    // Calculate on mount
    calculateBottomPadding();

    // Recalculate on resize (Safari UI bars appearing/disappearing)
    window.addEventListener('resize', calculateBottomPadding);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', calculateBottomPadding);
    }

    return () => {
      window.removeEventListener('resize', calculateBottomPadding);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', calculateBottomPadding);
      }
    };
  }, []);

  return (
    <nav
      className={cn(
        'z-50 h-16 w-full border-t border-gray-200 bg-white px-9 shadow-lg md:mx-auto md:mb-1 md:max-w-md md:pt-1',
        `pb-[env(safe-area-inset-bottom)]`
      )}
      // className={cn(
      //   'fixed bottom-0 left-0 right-0 z-50 h-16 w-full shadow-lg md:mx-auto md:mb-1 md:max-w-md md:pt-1',
      //   'border-t border-gray-200 bg-white px-9',
      //   `pb-[env(safe-area-inset-bottom)]`
      // )}
    >
      <div className="flex h-full items-center justify-between py-2">
        {navigationItems?.map(({ icon, label, to }) => (
          <Link to={to} key={label} replace={label === 'Home'}>
            <NavgationButton icon={icon} label={label} active={pathname === to} />
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default BottomNavigation;

const NavgationButton = ({ icon: Icon, label, active }) => (
  <div className="flex flex-col items-center justify-center">
    <Icon className="size-[22px] md:mb-1 md:size-6" />
    <span className={cn('text-[12px] text-foreground md:text-xs', active && 'font-semibold text-black')}>{label}</span>
  </div>
);
